import React from 'react'
import {
  Layout, Form, Input, Button, Typography, message,
} from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import Cookies from 'js-cookie'

import { fetch } from '../../utils/fetch'

const { Title } = Typography

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
}

const LoginPage = () => {
  const onFinish = (values) => {
    fetch({
      method: 'POST',
      url: '/user/login',
      data: values,
    }).then((response) => {
      if (response.status === 200) {
        const token = response.data?.data?.token
        Cookies.set(`oms-token-${process.env.REACT_APP_ENV}`, token)
        window.location.reload()
      } else {
        message.error(`${response?.data?.message}`)
      }
    })
  }

  return (
    <>
      <Layout style={{
        height: '100vh', display: 'flex', alignItems: 'center', backgroundColor: '#f6f6f7',
      }}
      >
        <>
          <div style={{
            width: 400, marginLeft: 'auto', marginRight: 'auto', padding: 60,
          }}
          >
            <div style={{ textAlign: 'center', marginTop: 60 }}><Title level={2}>OMS</Title></div>
            <Form
              {...formItemLayout}
              name="login_form"
              onFinish={onFinish}
            >
              <Form.Item
                name="username"
                rules={[
                  {
                    required: true,
                    message: 'Please input your Username!',
                  },
                ]}
              >
                <Input size="large" prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: 'Please input your Password!',
                  },
                ]}
              >
                <Input
                  size="large"
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  type="password"
                  placeholder="Password"
                />
              </Form.Item>
              <Form.Item>
                <Button size="large" type="primary" block htmlType="submit" className="login-form-button">
                  Log in
                </Button>
              </Form.Item>
            </Form>
          </div>
        </>
      </Layout>
    </>
  )
}

export default LoginPage
